import React from 'react';
import GlobalStyle from './global'
import LandingPage from './pages/landing'

function App() {
  return (
    <>
      <GlobalStyle />
      <LandingPage />
    </>
  );
}

export default App;
